<template>
  <article class="grocery-bag-recipe-block">
    <div class="grocery-bag-recipe-block__inner-wrapper row-noGutter">
      <div
        class="grocery-bag-recipe-block__media col-12_md-4_lg-6"
      >
        <cloudinary-picture
          :url="imageUrl"
          :sizes="dimensions"
          :sharpen="80"
          auto-quality="best"
          :use-picture="false"
          :aspect-ratio="0"
          :link-url="recipe.url"
          :alt="recipe.title"
        />
        <save-recipe-button-wrapper
          :recipe="recipe"
          :is-saved="recipe.userInteraction && recipe.userInteraction.recipeSaved"
          :button-size="saveButtonSize"
        />
      </div>
      <div class="col-12_md-8_lg-6">
        <div class="grocery-bag-recipe-block__content">
          <a
            :href="recipe.url"
            aria-label="Recept"
            class="grocery-bag-recipe-block__content-title font-rubrik-2--mid"
          >
            {{ recipe.title }}
          </a>

          <recipe-content-attributes
            :customer-rating="recipe.userInteraction && recipe.userInteraction.customerRate"
            :average-rating="recipe.rating.averageRating"
            :number-of-votes="recipe.rating.numberOfVotes"
            :number-of-comments="recipe.numberOfComments"
            :is-good-climate-choice="recipe.isGoodClimateChoice"
          />

          <div
            class="grocery-bag-recipe-block__content-preamble"
          >
            {{ recipe.preamble }}
          </div>
        </div>
        <div class="row-noGutter">
          <recipe-footer-attributes
            :cooking-time="recipe.cookingTime"
            :number-of-ingredients="recipe.numberOfIngredients"
            :difficulty="recipe.difficulty"
          />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import RecipeContentAttributes from '@/vue/components/recipes/recipeContentAttributes.vue'
import RecipeFooterAttributes from '@/vue/components/recipes/recipeFooterAttributes'
import SaveRecipeButtonWrapper from '@/vue/components/recipes/saveRecipeButtonWrapper'

export default {
  name: "RecipeBlockGb",
  components: {
    SaveRecipeButtonWrapper,
    RecipeFooterAttributes,
    RecipeContentAttributes
  },
  props: {
    recipe: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 767
        },
        medium: {
          width: 480
        },
        large: {
          width: 570
        }
      }
    }
  },
  computed: {
    imageUrl () {
      const r = this.recipe
      if(r.imageUrl) {
        return r.imageUrl
      } else if (r.images && r.images.length) {
        for (let i = 0; i < r.images.length; i++) {
          if(r.images[i].size === 'default'){
            return r.images[i].url
          }
        }
        return r.images[0].url
      }
      return ''
    },
    saveButtonSize () {
      if (this.$root.isSmallViewport) {
        return 40
      } else if (this.$root.isLargeViewport) {
        return 64
      } else {
        return 48
      }
    }
  }
}
</script>

<style lang="scss">
.grocery-bag-recipe-block {
  margin-bottom: 0.5rem;
  box-shadow: $box-shadow-primary;

  &__media {
    position: relative;

    .save-recipe-button {
      position: absolute;
      right: 0.75rem;
      top: 0.75rem;
    }
  }

  &__inner-wrapper {
    background-color: white;

    .grocery-bag-recipe-block__media {
      height: 9.5rem;

      @include media-breakpoint-up(md) {
        height: auto;
      }
    }
  }

  &__content {
    padding: 1rem;

    @include media-breakpoint-up(md) {
      padding: 2rem;
    }
  }

  &__content-title {
    display: block;
    color: $color-grey-dark;
    margin-bottom: 0.5rem;
  }

  &__content-preamble {
    margin-top: 0.5rem;
  }

  .recipe-content-attr {
    justify-content: start;

    &__rating {
      justify-content: start;
      margin-left: -0.125rem;
    }

    @include media-breakpoint-down(sm) {
      > div {
        @include font(text, 2, "bold");

        .recipe-content-attr__icon {
          height: 1.25rem;
        }
      }

      .recipe-content-attr__comments {
        line-height: 1.5rem;
      }
    }
  }

  .epi-picture {
    display: block;
    height: 100%;
    padding: 0.5rem 0.5rem 0.5rem 0;

    .epi-background-container {
      border-radius: 4px;
      height: 100%;
    }

    @include media-breakpoint-up(md) {
      padding: 0;

      .epi-background-container {
        border-radius: 0;
      }
    }
  }
}
</style>
